export const getArtworkSize = (width, height) => {
  const w = width && parseFloat(width) !== 0 ? parseFloat(width) + `" W` : ``
  const h = parseFloat(height) + `" H`
  return w ? h + ` x ` + w : h
}
